import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  ratingRoot: {
    '& > span:not(:last-child)': {
      marginRight: 10,
    }
  },
}))